import React, { type FunctionComponent } from 'react'
import { UnlockedIcon } from '@instacart/ids-core'
import { spacing, Tooltip } from '@retailer-platform/shared-components'
import styled from '@emotion/styled'
import { type OverrideType } from 'domains/products/api'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

const IconButton = styled.button(() => ({
  display: 'flex',
  flexDirection: 'column',
  border: 'none',
  backgroundColor: 'transparent',
  padding: `0 ${spacing.X4}`,
  margin: 0,
  cursor: 'pointer',
  ':hover svg': {
    opacity: 0.5,
  },
}))

interface OverrideIconProps {
  valueBasedOverride: {
    attributeName: string
    username: string
    createdWhy: string
    overrideType: OverrideType
    expiryDate: string
    overrideValue: string
    sourceValue: string
    ticketUrl: string
  }
  onClick?: () => void
}

export const OverrideIcon: FunctionComponent<OverrideIconProps> = ({
  valueBasedOverride,
  onClick,
}) => {
  const i18n = useDomainMessages({
    hasOverrideMessage: 'productsDomain.view.details.sections.override.has',
    noOverrideMessage: 'productsDomain.view.details.sections.override.none',
  })

  return (
    <Tooltip
      placement={'top'}
      target={
        <IconButton
          onClick={() => {
            if (onClick) onClick()
          }}
        >
          <UnlockedIcon
            size={16}
            color={valueBasedOverride ? 'brandHighlightRegular' : 'systemGrayscale30'}
          />
        </IconButton>
      }
    >
      {valueBasedOverride
        ? `${i18n.hasOverrideMessage} ${valueBasedOverride.expiryDate}`
        : i18n.noOverrideMessage}
    </Tooltip>
  )
}
